import React from "react";
import type { Casting } from "@/types";
import { Button } from "@/components/atoms";
import { format as dateFormat } from "date-fns";
import { GENDER_LABELS, PAYMENT_TYPE_LABELS } from "@/constants";
import "./CastingCard.scss";

interface CastingCardProps {
  casting: Casting;
  onApply?: () => void;
}

const hasContactInfo = (contact: Casting["contact"]) =>
  contact.phone || contact.email || contact.instagram || contact.externalLink;

/**
 * Card component to display a casting call summary
 * @component
 */
export const CastingCard: React.FC<CastingCardProps> = ({
  casting,
  onApply,
}) => {
  return (
    <div className="casting-card">
      <h2 className="casting-card__title">{casting.title}</h2>
      <div className="casting-card__alignment" />
      <div className="casting-card__badges">
        <p className="casting-card__badge casting-card__badge--payment">
          {PAYMENT_TYPE_LABELS[casting.paymentType]}
        </p>
        <p className="casting-card__badge casting-card__badge--genre">
          {GENDER_LABELS[casting.gender]}
        </p>
      </div>
      <div className="casting-card__alignment" />
      <div className="casting-card__description">
        <p>{casting.fisic}</p>
        <p>{casting.description}</p>
      </div>
      <div className="casting-card__alignment" />
      <div className="casting-card__footer">
        <p>Cierre: {dateFormat(casting.endDate, "dd/MM/yyyy")}</p>
        {hasContactInfo(casting.contact) && onApply && (
          <Button
            variant="primary"
            fullWidth
            motionScale="lg"
            onClick={onApply}
            actionTrackSufix="casting-list__apply"
          >
            Aplicar
          </Button>
        )}
      </div>
    </div>
  );
};

export default CastingCard;
